module.exports = __webpack_public_path__ + "img/left.6bda60af.svg";